import { render, staticRenderFns } from "./HomePagePasswordChangeHist.vue?vue&type=template&id=aca72b60&scoped=true&"
import script from "./HomePagePasswordChangeHist.vue?vue&type=script&lang=js&"
export * from "./HomePagePasswordChangeHist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aca72b60",
  null
  
)

export default component.exports